import { IconsProps } from '@/types/shared'
import React from 'react'

const NonInvoicableIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <circle cx="12" cy="12" r="10" />
                <line x1="9" x2="15" y1="15" y2="9" fill="currentColor" />
            </svg>
        </div>
    )
}

export default NonInvoicableIcons
